<template>
  <div class="toolbar" v-if="config.active" qa="wht-toolbar">
    <div :data-balloon="fill" data-balloon-pos="right" v-if="config.fill" @click="callback('fill')"><span class="icon fill" :style="fillStyle()"><span v-if="noFill" class="none"></span></span></div>
    <div data-balloon="Border" data-balloon-pos="right" v-if="config.border" @click="callback('border')"><span class="icon border" :style="borderStyle()"><span v-if="noBorder" class="none"></span></span></div>
    <div :data-balloon="text" data-balloon-pos="right" v-if="config.text" @click="callback('text')" :style="textStyle()"><span class="icon text"><i class="fal fa-font"></i></span></div>
    <div :data-balloon="bringToFront" data-balloon-pos="right" @click="callback('bringToFront')"><span class="icon send-front"><i class="fal fa-arrow-alt-to-top"></i></span></div>
    <div :data-balloon="sendToBack" data-balloon-pos="right" @click="callback('sendToBack')"><span class="icon send-back"><i class="fal fa-arrow-alt-to-bottom"></i></span></div>
  </div>
</template>

<script>
import i18n from '@/i18n'

export default {
  props: ['config', 'callback', 'styleSettings'],
  data: function () {
    return {
      fill: i18n.t('magicboard.fill'),
      text: i18n.t('magicboard.text'),
      bringToFront: i18n.t('magicboard.bringToFront'),
      sendToBack: i18n.t('magicboard.sendToBack')
    }
  },
  computed: {
    noFill: function () {
      return this.styleSettings.supportsFill && this.styleSettings.fill.none
    },
    noBorder: function () {
      return this.styleSettings.supportsBorder && this.styleSettings.border.width === 0
    }
  },
  methods: {
    fillStyle: function () {
      let colour = 'inherit'
      if (this.styleSettings.supportsFill) {
        if (this.styleSettings.fill.none) {
          colour = 'transparent'
        } else {
          colour = this.styleSettings.fill.colour
        }
      } else if (this.styleSettings.supportsBorder) {
        colour = this.styleSettings.border.colour
      }

      return `background: ${colour}`
    },
    borderStyle: function () {
      let colour = 'inherit'
      const width = 3
      if (this.styleSettings.supportsBorder) {
        if (this.styleSettings.border.width === 0) {
          colour = 'transparent'
        } else {
          colour = this.styleSettings.border.colour
        }
      }

      return `border: solid ${width}px ${colour}`
    },
    textStyle: function () {
      return `color: ${this.styleSettings.text.colour}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.toolbar {
  position: absolute;
  bottom: 150px;
  left: 2rem;
  border-radius: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  background: white;
  display: flex;
  flex-direction: column;
  padding: 0.75rem 0;

  div {
    flex-basis: 3rem;
    flex-grow: 0;
    flex-shrink: 0;
    width: 3rem;
    height: 3rem;
    cursor: pointer;
    font-size: 2rem;
    text-align: center;
    margin: auto;

    &:hover {
      border-radius: 10px;
      background: whitesmoke;
    }

    .fill, .border {
      border-radius: 5px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    }

    .text {
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    }
  }

  .none {
    width: 1.9rem;
    height: 1.9rem;
    border-bottom: 2px solid red;
    -webkit-transform:
        translateY(-0.6rem)
        translateX(0.6rem)
        rotate(45deg);
    position: absolute;
    /* top: -20px; */
    }

  .send-front, .send-back {
    font-size: 1.1rem;
  }
}

@include mobile {
  .toolbar {
    width: 11.5rem;
    flex-direction: row;
    justify-content: center;
    bottom: 2px;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 0 0.75rem;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-basis: 0;
      height: 2.5rem;
      margin: 0;
      padding: 0 0.5rem;
    }
  }
}
</style>
